const { h, render, Component } = require('preact');

class BreadcrumbSeparator extends Component {
    constructor(props) {
        super(props)
    }

    render() {
      return (
            <li class="bc_sep">›</li>
      )
    }
}

module.exports = BreadcrumbSeparator
